import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Row, Col } from 'react-bootstrap';
import api from '../../services/api';
import Layout from '../../components/Layout';
import { Container } from 'react-bootstrap';
import TopBar from '../../components/TopBar';
import { Card, CardGroup } from 'react-bootstrap';
import { FaSave } from 'react-icons/fa';

const LeaveSetup = () => {
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [employees, setEmployees] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [types, setTypes] = useState([]);
  const [quotas, setQuotas] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        const response = await api.get('/leave-types');
        console.log('Fetched leave types:', response.data); // Debug log
        setTypes(response.data);
        setQuotas(response.data.map(t => ({ leave_type_id: t.id, allocated: 0 })));
      } catch (error) {
        console.error('Error fetching leave types:', error);
      }
    };

    const fetchEmployees = async () => {
      try {
        const response = await api.get('/employees');
        setEmployees(response.data);
      } catch (error) {
        console.error('Error fetching employees:', error);
      }
    };

    fetchLeaveTypes();
    fetchEmployees();
  }, []);

  const handleSelectEmployee = (e) => {
    setSelectedEmployee(e.target.value);
  };

  const handleChange = (index, value) => {
    const newQuotas = [...quotas];
    newQuotas[index].allocated = value;
    setQuotas(newQuotas);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/leave/quotas/setup', {
        employee_id: selectedEmployee,
        year,
        quotas
      });
      setMessage('Leave quotas set successfully');
      setSelectedEmployee('');
      setQuotas(types.map(t => ({ leave_type_id: t.id, allocated: 0 })));
    } catch (err) {
      setMessage('Failed to set quotas');
    }
  };

  return (
    <Layout>
      <TopBar title="Leave Setup" />
      <Container fluid className="mt-4" style={{ maxHeight: '85vh', overflowY: 'auto' }}>
        <Card className="shadow-sm">
          <Card.Body>
            <h4 className="mb-4">Leave Quota Setup</h4>
            <Form onSubmit={handleSubmit}>
              {message && (
                <Alert variant="success" className="mb-3">
                  {message}
                </Alert>
              )}
              <div className="text-end mt-3">
                <Button
                  type="submit"
                  variant="primary"
                  size="sm"
                  disabled={!selectedEmployee || !types.length}
                >
                  <FaSave className="me-1" />
                  Save
                </Button>
              </div>

              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Select Employee</Form.Label>
                    <Form.Select
                      value={selectedEmployee}
                      onChange={handleSelectEmployee}
                      className="mb-3"
                    >
                      <option value="">Select Employee</option>
                      {employees.map(emp => (
                        <option key={emp.user_id} value={emp.user_id}>
                          {emp.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Year</Form.Label>
                    <Form.Control
                      type="number"
                      value={year}
                      onChange={e => setYear(e.target.value)}
                      min="2000"
                      max="2099"
                      className="mb-3"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Leave Type</th>
                      <th>Allocated Days</th>
                    </tr>
                  </thead>
                  <tbody>
                    {types && types.length > 0 ? (
                      types.map((type, index) => (
                        <tr key={type.id || index}>
                          <td>{type.name}</td>
                          <td>
                            <Form.Control
                              type="number"
                              value={quotas.find(q => q.leave_type_id === type.id)?.allocated || 0}
                              onChange={e => {
                                const quotaIndex = quotas.findIndex(q => q.leave_type_id === type.id);
                                if (quotaIndex >= 0) {
                                  handleChange(quotaIndex, e.target.value);
                                } else {
                                  // If not found, add new quota
                                  const newQuota = {
                                    leave_type_id: type.id,
                                    allocated: parseFloat(e.target.value) || 0
                                  };
                                  setQuotas([...quotas, newQuota]);
                                }
                              }}
                              min="0"
                              step="0.1"
                              className="w-100"
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2" className="text-center">No leave types found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>


            </Form>
          </Card.Body>
        </Card>
      </Container>
    </Layout>
  );
};

export default LeaveSetup;